import React from 'react'
import PropTypes from 'prop-types'
import {
  Segment,
  Container,
  Grid,
  Icon,
  Tab,
} from 'semantic-ui-react'

const propTypes = {
  pageData: PropTypes.object.isRequired
}

const Reference = () => (
  <div>
    <Segment basic>
      <Container>
        <h3 id="category-title">Reference</h3>
        <Grid columns="three" stackable divided padded>
          <Grid.Row style={{marginBottom: 5}}>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='https://www.facebook.com/gostilnica.trgovinica.Strudl'>Gostilnica-trgovinica Štrud´l</a>
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='https://www.bohinj.si'>Turizem Bohinj</a>
              </h4>
            </Grid.Column>

            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='https://www.vodni-park-bohinj.si/'>Vodni park Bohinj</a>
              </h4>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{marginBottom: 5}}>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='http://www.vogel.si/poletje'>Žičnice Vogel</a>
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='https://www.zd-bohinj.si/'>Zdravstveni dom Bohinj</a>
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='http://www.zavodsvetegamartina.si/domov.html'>Zavod svetega Martina</a>
              </h4>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{marginBottom: 5}}>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='http://www.cudv-ml.si/kdo_smo.htm'>CUDV Matevža Langusa</a>
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                GRS Bohinj
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='http://www.ggbled.si/'>GG Bled</a>
              </h4>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{marginBottom: 5}}>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='http://www.alpik.com/'>Apartmaji Alpik</a>
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='http://ld-turizem.si/'>LD turizem</a>
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='http://www.hotel-kristal-slovenia.com/'>Hotel Kristal</a>
              </h4>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{marginBottom: 5}}>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='http://www.hotel-bohinj.si/'>Hotel Tripič</a>
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                <a style={{color: 'black'}} href='http://www.gostilna-rupa.si/'>Gostilna Rupa</a>
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                Kava bar Rondo
              </h4>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{marginBottom: 5}}>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                Kava bar Kobla
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
              Frizerski studio ML LINE
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                Frizerski studio K STYLING
              </h4>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{marginBottom: 5}}>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
                Frizerija Klaudija Rauter
              </h4>
            </Grid.Column>
            <Grid.Column>
              <h4 id="article-title">
                <Icon name="asexual" color="black" size="large" />
              Stanovanjske hiše in drugi poslovni prostori
              </h4>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  </div>
)

Reference.propTypes = propTypes
export default Reference



// WEBPACK FOOTER //
// ./src/pages/reference/Reference.js